var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_c('Icon',{staticStyle:{"margin-bottom":"-4px","margin-right":"4px"},attrs:{"name":"two-dots","size":"18"}}),_vm._v(" "),_vm._t("default",function(){return [_c('span',{staticClass:"text-14 font-bold tracking-tightest"},[_vm._v(_vm._s(_vm.text))])]},null,{ points: _vm.points, text: _vm.text })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }